import CommonUtil from "../utils/CommonUtil";

class CredentialsValidator {
  validate(username, password) {
    return CommonUtil.isEveryStringNotEmpty([username, password]);
  }
}

export default CredentialsValidator;
